import styled from 'styled-components';
import { H2 } from 'utils/styles/typography';

export default styled(H2)`
  margin: 1rem 0;
`;
